/**
 * vue prop
 *
 * @author Shigq
 * @date 2021/4/16 15:19
 */
var {ElLoading, ElMessage, ElMessageBox} = require('element-plus')
var componentConfig = require('../config/component.config')

/**
 * global loading
 *
 * @param text
 * @returns {*}
 */
function baseLoading(text) {
	return ElLoading.service({
		lock: true,
		text: text || componentConfig.loading.text,
		background: componentConfig.loading.background
	})
}

/**
 * global message
 *
 * @param message
 * @param type
 */
function baseMessage(message, type) {
	ElMessage({
		offset: componentConfig.message.offset,
		showClose: true,
		message: message || componentConfig.message.message,
		type: type || componentConfig.message.type,
		dangerouslyUseHTMLString: true,
		duration: componentConfig.message.duration,
	})
}

/**
 * global alert
 *
 * @param content
 * @param title
 * @param callback
 */
function baseAlert(content, title, callback) {
	ElMessageBox.alert(content || componentConfig.messageBox.content, title || componentConfig.messageBox.title, {
		confirmButtonText: componentConfig.messageBox.confirmButtonText,
		dangerouslyUseHTMLString: true,
		callback: (action) => {
			if (callback) {
				if (action === 'confirm') {
					if (callback) {
						callback(action)
					}
				} else {
					// todo - cancel
				}
			}
		},
	})
}

/**
 * global confirm
 *
 * @param content
 * @param title
 * @param options
 * @param callback1
 * @param callback2
 */
function baseConfirm(content, title, options, callback1, callback2) {
	ElMessageBox.confirm(content, title || componentConfig.messageBox.title, {
		confirmButtonText: componentConfig.messageBox.confirmButtonText,
		cancelButtonText: componentConfig.messageBox.cancelButtonText,
		closeOnClickModal: false,
		type: componentConfig.messageBox.type,
		...options
	})
		.then(() => {
			if (callback1) {
				callback1()
			}
		})
		.catch(() => {
			if (callback2) {
				callback2()
			}
		})
}

/**
 * global prompt
 *
 * @param content
 * @param title
 * @param options
 * @param callback1
 * @param callback2
 */
function basePrompt(content, title, options, callback1, callback2) {
	ElMessageBox.prompt(content, title || componentConfig.messageBox.title, options)
	.then(({ value }) => {
		if (callback1) {
			callback1(value)
		}
	})
	.catch(() => {
		if (callback2) {
			callback2()
		}
	})
}

module.exports = {
	baseAlert,
	baseConfirm,
	baseLoading,
	baseMessage,
	basePrompt
}

